<script setup>
defineProps({plant:{type:Object,required:true}});const {selected,toggle}=usePlantComparison();
</script>
<template><button type="button" class="uo-choice-compare" :aria-pressed="selected(plant.id)" @click="toggle(plant)">{{selected(plant.id)?'В сравнении ✓':'Сравнить'}}</button></template>
